import { colorPalette } from "../../design/productConfig";
import type { TripReport } from "../../types/traffic";

function formatDuration(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const remainder = Math.floor(seconds % 60);
  return `${minutes}:${String(remainder).padStart(2, "0")}`;
}

export async function createLocalShareCard(report: TripReport): Promise<Blob> {
  const canvas = document.createElement("canvas");
  canvas.width = 1080;
  canvas.height = 1350;
  const context = canvas.getContext("2d");
  if (!context) throw new Error("Canvas 2D is unavailable.");

  const gradient = context.createLinearGradient(0, 0, 1080, 1350);
  gradient.addColorStop(0, "#30284D");
  gradient.addColorStop(0.44, "#14181C");
  gradient.addColorStop(1, "#0B0D0F");
  context.fillStyle = gradient;
  context.fillRect(0, 0, 1080, 1350);

  context.fillStyle = "#FF5A1F";
  context.fillRect(72, 72, 12, 150);
  context.fillStyle = "#F4F1E8";
  context.font = "700 34px sans-serif";
  context.fillText("THE INTERNET", 112, 118);
  context.font = "800 62px sans-serif";
  context.fillText("TRAFFIC JAM", 108, 182);

  context.fillStyle = "#B8BCC2";
  context.font = "600 25px sans-serif";
  context.fillText("PEAK WEBSITE TRAFFIC", 72, 330);
  context.fillStyle = "#F4F1E8";
  context.font = "800 168px sans-serif";
  context.fillText(report.peakDriverCount.toLocaleString(), 64, 482);
  context.fillStyle = "#FF5A1F";
  context.font = "700 34px sans-serif";
  context.fillText(`${report.worstState} · DRIVERS`, 74, 540);

  const bodyColor =
    report.profile.colorId in colorPalette
      ? colorPalette[report.profile.colorId as keyof typeof colorPalette]
      : 0xff5a1f;
  context.save();
  context.translate(540, 760);
  context.fillStyle = `#${bodyColor.toString(16).padStart(6, "0")}`;
  context.beginPath();
  context.roundRect(-145, -210, 290, 420, 70);
  context.fill();
  context.fillStyle = "#171B20";
  context.beginPath();
  context.roundRect(-100, -142, 200, 132, 28);
  context.fill();
  context.fillStyle = "#FF304F";
  context.fillRect(-110, 145, 55, 30);
  context.fillRect(55, 145, 55, 30);
  context.fillStyle = "#F4F1E8";
  context.fillRect(-66, 120, 132, 52);
  context.fillStyle = "#111317";
  context.font = "800 28px sans-serif";
  context.textAlign = "center";
  context.fillText(report.profile.plate, 0, 156);
  context.restore();

  const metrics = [
    ["TIME IN TRAFFIC", formatDuration(report.elapsedSeconds)],
    ["DISTANCE", `${report.distanceMiles.toFixed(2)} MI`],
    ["EST. DELAY ADDED", `${report.addedDelaySeconds.toFixed(1)} SEC`],
  ] as const;
  metrics.forEach(([label, value], index) => {
    const x = 72 + index * 330;
    context.fillStyle = "#B8BCC2";
    context.font = "600 18px sans-serif";
    context.textAlign = "left";
    context.fillText(label, x, 1080);
    context.fillStyle = "#F4F1E8";
    context.font = "700 34px sans-serif";
    context.fillText(value, x, 1125);
  });

  context.strokeStyle = "rgba(244,241,232,.25)";
  context.beginPath();
  context.moveTo(72, 1178);
  context.lineTo(1008, 1178);
  context.stroke();
  context.fillStyle = "#F4F1E8";
  context.font = "800 48px sans-serif";
  context.fillText("COME MAKE IT WORSE", 72, 1260);

  return await new Promise<Blob>((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) resolve(blob);
      else reject(new Error("Could not create share image."));
    }, "image/png");
  });
}
